<template>
	<div class="mt-5 mb-3">
		<v-checkbox v-model="formCheckbox.status" v-bind:label="formCheckbox.text" aria-label="checkbox status"
			:disabled="disabled || formCheckbox.isDisabled"></v-checkbox>
		<v-expand-transition>
			<div v-if="formCheckbox.status">
				<v-btn
					:disabled="disabled"
					v-if="!contestFormDefined" @click="defineForm">
					Utwórz formularz
				</v-btn>
				<v-dialog v-model="contestDialog" max-width="500px">
					<v-btn
						:disabled="disabled"
						slot="activator" v-if="!contestFormDefined" @click="getContestNames">
						Wybierz formularz
					</v-btn>
					<v-card>
						<v-card-title>
							<span class="headline">Wybierz formularz z naboru</span>
						</v-card-title>
						<v-card-text>
							<v-autocomplete
								v-model="chosenContest"
								:filter="customFilter"
								item-text="name"
								item-value="id"
								:items="contests"
								label="Nabór"
								aria-label="contest"
								for="agency-contest-form-item-recruitment"
								id="agency-contest-form-item-recruitment"
							></v-autocomplete>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="blue" @click="cancelAndCloseDialog">Anuluj</v-btn>
							<v-btn color="primary" flat @click="saveAndCloseDialog">Zapisz</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<v-btn
					:disabled="disabled"
					v-if="contestFormDefined" @click="defineForm">
					Edytuj formularz
				</v-btn>
				<v-btn
					:disabled="disabled"
					v-if="contestFormDefined" @click="deleteOfferForm">
					Usuń formularz
				</v-btn>
				<v-btn
					color="primary"
					v-if="contestFormDefined" 
					@click="printFormPreview"
					:disabled="printLoading"
					:loading="printLoading">
					{{ printLoading ? 'Proszę czekać...' : 'Drukuj' }}
				</v-btn>
				<span class="ml-3" v-if="contestFormDefined">
					<v-icon large class="mr-2" style="color: lightseagreen">check</v-icon>
				</span>
			</div>
		</v-expand-transition>
	</div>
</template>

<script>
	import {Api} from "@/api";
	import {AgencyContest} from "@/api/generated/AgencyContest";
	import {Files} from "@/utils/Files";

	export default {
		name: "AgencyContestFormItem",

		props: {
			formDefined: {
				type: Boolean,
			},
			checkbox: {
				type: Object,
			},
			disabled: {
				type: Boolean,
				default: false,
			},
		},

		watch: {
			formDefined: function () {
				this.contestFormDefined = this.formDefined;
			},
			checkbox: function () {
				this.formCheckbox = this.checkbox;
			},

			"formCheckbox.status": function (val) {
				Api.put(this, "/agency-contest/form-status", {
					contestId: this.$route.params.id,
					agencyContestFormType: this.formCheckbox.formType,
					status: val,
				}, () => {
					this.formCheckbox.status = val;
				});
			},
		},

		methods: {
			getContestNames() {
				Api.getWithParam(this, "/agency-contest/" + this.formCheckbox.formType.toLowerCase().replace("_", "-") + "-names",
					{contestId: this.$route.params.id}, response => {
						this.contests = response.sort((a, b) => a.name.localeCompare(b.name));
					});
			},

			customFilter(item, queryText) {
				const textOne = item.name.toLowerCase();
				const searchText = queryText.toLowerCase();
				return textOne.indexOf(searchText) > -1;
			},

			saveAndCloseDialog() {
				AgencyContest.postForm(this, {
					fromContestId: this.chosenContest,
					toContestId: this.$route.params.id,
					agencyContestFormType: this.formCheckbox.formType,
				}, () => {
					this.contestFormDefined = true;
					this.$emit("form-chosen");
				});
				this.contestDialog = false;
			},

			cancelAndCloseDialog() {
				this.contestDialog = false;
			},

			defineForm() {
				// id to id naboru
				this.$router.push("/app/form-generator/AGENCY/" + this.$route.params.id + "/" + this.formCheckbox.formType);
			},

			deleteOfferForm() {
				AgencyContest.deleteForm(this, this.$route.params.id, this.formCheckbox.formType, () => {
					this.$emit("form-deleted");
					this.contestFormDefined = false;
					this.formCheckbox.status = this.formCheckbox.formType === "OFFER";
				});
			},

			async printFormPreview() {
				this.printLoading = true;
				const contestId = this.$route.params.id;
				const formType = this.formCheckbox.formType;
				const reportId = this.formCheckbox.id;
				const formTitle = this.getFormTypeLabel(formType);
				
				await Files.methods.downloadFileAsBlob(
					this,
					Files.methods.getAgencyFormPrintUrl(contestId, formType, reportId),
					`formularz_${formTitle}.pdf`
				);
				
				this.printLoading = false;
			},

			getFormTypeLabel(formType) {
				const labels = {
					'OFFER': 'wniosek',
					'INDIVIDUAL_EVALUATION': 'indywidualna_opinia',
					'EXPERT_EVALUATION': 'opinia_eksperta',
					'FINAL_EVALUATION': 'opinia_koncowa',
					'MONITORING_REPORT': 'raport_monitoringu',
					'FINAL_REPORT': 'sprawozdanie_koncowe'
				};
				return labels[formType] || 'formularz';
			},
		},

		data() {
			return {
				scoreSavedSnackBar: false,
				contests: [],
				formTypeMap: [],
				formCheckbox: this.checkbox,
				chosenContest: undefined,
				contestFormDefined: this.formDefined,
				contestDialog: false,
				printLoading: false,
			};
		},
	};
</script>

<style scoped>

</style>
